import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Button from '@chama/ui-components/components/ButtonNew';
import { FormattedMessage } from 'react-intl';

import './SaveControls.css';

export default function SaveControls({
  editModeEnabled,
  onEnableEditMode,
  onSubmit,
  onCancel,
  saveDisabled,
  classes,
}) {
  const buttons = editModeEnabled ? (
    <Fragment>
      <Button variant="secondary" onClick={onCancel}>
        <FormattedMessage id="cancel" />
      </Button>
      <Button variant="primary" onClick={onSubmit} isDisabled={saveDisabled}>
        <FormattedMessage id="save_edition" />
      </Button>
    </Fragment>
  ) : (
    <Button variant="primary" onClick={onEnableEditMode}>
      <FormattedMessage id="edit" />
    </Button>
  );
  return <div className={classnames('CoverageAreaMap__map-savecontrols', classes)}>{buttons}</div>;
}

SaveControls.propTypes = {
  editModeEnabled: PropTypes.bool.isRequired,
  saveDisabled: PropTypes.bool.isRequired,
  onEnableEditMode: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  classes: PropTypes.string,
};

SaveControls.defaultProps = {
  classes: '',
};



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/SaveControls/SaveControls.jsx